import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import { epoch, utc } from '../../util/datetime';
import type { IIncome } from './Income.interface';
import { IncomeType } from './Income.enum';
import IncomeBusiness from './IncomeBusiness';
import IncomePAYG from './IncomePAYG';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';

export default class Income implements IIncome {
  id: string;
  incomeType: IncomeType;
  grossValue: number;
  description: string;
  frequency: PaymentFrequency;
  payg: IncomePAYG;
  business: IncomeBusiness;
  idContact: string;
  idEmployer: string;
  timeStamp: number;
  isActive: boolean;

  getName() {
    let { name } = this;
    if (this.incomeType.id === Income.getAvailableIncomeTypes()[0].id) {
      const n = this.name.split(' ');
      name = `${n[0].toUpperCase()} ${n[1]}`;
    }
    return name;
  }

  isIncomeTypePayg() {
    return this.incomeType.id === Income.getAvailableIncomeTypes()[0].id;
  }

  isIncomeTypeBusiness() {
    return this.incomeType.id === Income.getAvailableIncomeTypes()[1].id;
  }

  isIncomeTypeOtherTaxable() {
    return this.incomeType.id === Income.getAvailableIncomeTypes()[2].id;
  }

  isIncomeTypeNonTaxable() {
    return this.incomeType.id === Income.getAvailableIncomeTypes()[3].id;
  }

  static getAvailableIncomeTypes = () => IncomeType.available();

  static build = (data: IIncome) => new Income(data);
  static blank = (incomeType) => new Income({ id: uuid(), incomeType, isActive: true });

  /**
   * Constructor
   * @param {IIncome} data
   */
  constructor(data?: IIncome) {
    this.id = toUUID(data?.id) || uuid();
    this.incomeType = IncomeType.of(data?.incomeType?.id || data?.incomeType?.name);
    this.grossValue = parseFloat(data?.grossValue || 0);
    this.description = data?.description || '';
    this.frequency = PaymentFrequency.of(data?.frequency?.name || `f${data?.frequency}`);
    this.payg = new IncomePAYG(data?.payg);
    this.business = new IncomeBusiness(data?.business);
    this.idContact = toUUID(data?.idContact);
    this.idEmployer = toUUID(data?.idEmployer);
    this.timeStamp = epoch(utc(data?.timeStamp));
    this.isActive = data?.isActive === true;
  }
}
